import Raven from 'raven-js';
import AccountsAPI from './API';
import { List, Set as ImmutableSet } from 'immutable';
import RequestStatusTypes from 'hub-pickers-lib/constants/RequestStatusTypes';
import Account from './records/Account';
import { sortByField } from '../utils/sorts';
let accounts = null;
let pinnedAccounts = null;
let hubsFailedToLoad = false;
let accountsRequestStatus = RequestStatusTypes.UNINITIALIZED;

// Academy Practice Mode portals should only be entered via their dedicated
// CTAs, so we drop them from the account list and from the pinned/default
// references.
// TODO (2026-11-06): replace/remove this portal-name filtering once
// a dedicated Academy Practice Mode hub type exists, so we can filter by hub
// type instead of a hardcoded name.
const ACADEMY_PRACTICE_MODE_NAME = 'Academy Practice Mode';
export function excludeAcademyPracticeModeAccounts(payload) {
  const visibleAccounts = List(payload.accounts.filter(account => account.accountName !== ACADEMY_PRACTICE_MODE_NAME).map(account => Account(account).set('products', ImmutableSet(account.products)))).sort(sortByField('accountName'));
  const visibleAccountIds = new Set(visibleAccounts.map(account => account.id));
  return {
    accounts: visibleAccounts,
    pinnedAccounts: List(payload.pinnedAccountIds.filter(id => visibleAccountIds.has(id))),
    defaultPortal: payload.defaultPortal != null && visibleAccountIds.has(payload.defaultPortal) ? payload.defaultPortal : null
  };
}
function getAccounts(includePins = false, includeStats = true) {
  if (!accounts) {
    accountsRequestStatus = RequestStatusTypes.PENDING;
    return AccountsAPI.getAccounts(includePins, includeStats).then(payload => {
      accountsRequestStatus = RequestStatusTypes.SUCCEEDED;
      const visible = excludeAcademyPracticeModeAccounts(payload);
      accounts = visible.accounts;
      pinnedAccounts = visible.pinnedAccounts;
      hubsFailedToLoad = payload.hubsFailedToLoad;
      if (accounts.size === 0) {
        Raven.captureMessage('Received empty list of accounts');
      }
      return {
        accounts,
        pinnedAccounts,
        accountsRequestStatus,
        hubsFailedToLoad,
        crossHublet: payload.crossHublet
      };
    }).catch(error => {
      Raven.captureException(error);
      accountsRequestStatus = RequestStatusTypes.FAILED;
      accounts = List();
      return {
        accounts,
        accountsRequestStatus
      };
    });
  }
  return Promise.resolve({
    accounts,
    accountsRequestStatus
  });
}
function getAccountsCrossHublet(includePins = false, includeStats = true) {
  if (!accounts) {
    accountsRequestStatus = RequestStatusTypes.PENDING;
    return AccountsAPI.getAccountsCrossHublet(includePins, includeStats).then(payload => {
      accountsRequestStatus = RequestStatusTypes.SUCCEEDED;
      const visible = excludeAcademyPracticeModeAccounts(payload);
      accounts = visible.accounts;
      pinnedAccounts = visible.pinnedAccounts;
      hubsFailedToLoad = payload.hubsFailedToLoad;
      if (accounts.size === 0) {
        Raven.captureMessage('Received empty list of accounts');
      }
      return {
        accounts,
        pinnedAccounts,
        defaultPortal: visible.defaultPortal,
        accountsRequestStatus,
        hubsFailedToLoad,
        crossHublet: payload.crossHublet
      };
    }).catch(error => {
      Raven.captureException(error);
      accountsRequestStatus = RequestStatusTypes.FAILED;
      accounts = List();
      return {
        accounts,
        accountsRequestStatus
      };
    });
  }
  return Promise.resolve({
    accounts,
    pinnedAccounts,
    accountsRequestStatus,
    hubsFailedToLoad
  });
}
function getAccountsRequestStatus() {
  return accountsRequestStatus;
}
function setPinnedAccounts(updatedPinnedAccounts) {
  return AccountsAPI.setPinnedAccounts(updatedPinnedAccounts).then(payload => {
    pinnedAccounts = List(payload);
    return pinnedAccounts;
  });
}
function setDefaultAccount(portalId) {
  return AccountsAPI.setDefaultAccount(portalId).then(payload => {
    return payload.defaultPortal.portalId;
  }).catch(error => {
    Raven.captureException(error);
    throw error;
  });
}
function deleteDefaultAccount() {
  return AccountsAPI.deleteDefaultAccount().then(payload => {
    return payload.defaultPortal;
  }).catch(error => {
    Raven.captureException(error);
    throw error;
  });
}
export { getAccounts, getAccountsCrossHublet, getAccountsRequestStatus, setPinnedAccounts, setDefaultAccount, deleteDefaultAccount };